import { render, staticRenderFns } from "./TestVocacional.vue?vue&type=template&id=74b70311&"
import script from "./TestVocacional.vue?vue&type=script&lang=js&"
export * from "./TestVocacional.vue?vue&type=script&lang=js&"
import style0 from "./TestVocacional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports